import { MapPin, GraduationCap, Building2, Trophy, Linkedin } from "lucide-react";

const facts = [
  { icon: Building2, label: "Currently: Principal Security Engineer, DigiNova Tech Global — Mumbai" },
  { icon: GraduationCap, label: "BCA, Chandigarh University (2022)" },
  { icon: MapPin, label: "Mumbai, India — Available for remote engagements globally" },
  { icon: Trophy, label: "CrowdStrike APJ Best Partner MVP 2023–24" },
];

export default function About() {
  return (
    <section id="about" className="py-20 md:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Image */}
          <div className="lg:col-span-5 flex items-start justify-center">
            <img
              src="/photo.jpg"
              alt="Piyus Kumar"
              className="w-[240px] h-[240px] md:w-[320px] md:h-[320px] max-w-[320px] max-h-[320px] rounded-full object-cover object-[center_15%] border-[3px] border-[#06B6D4] shadow-[0_8px_32px_rgba(0,0,0,0.12)]"
              data-testid="about-headshot"
            />
          </div>

          {/* Text */}
          <div className="lg:col-span-7 space-y-6">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#06B6D4]">About Me</span>
            <h2 className="font-['Outfit'] text-3xl sm:text-4xl font-bold tracking-tight text-[#111827]">
              Security-First. Always.
            </h2>
            <div className="space-y-4 text-base leading-relaxed text-[#6B7280]">
              <p>
                I'm Piyus Kumar, a Principal Security Engineer based in Mumbai with 5+ years of hands-on experience in enterprise cybersecurity. I specialize in deploying and operationalizing security platforms at scale — from EDR and identity protection to cloud security and next-gen SIEM.
              </p>
              <p>
                ShiftLeft Security is my philosophy: move security left, catch threats earlier, and build resilience into systems before incidents happen — not after.
              </p>
            </div>

            {/* Facts grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
              {facts.map((f) => (
                <div key={f.label} className="flex items-start gap-3 p-3 rounded-xl bg-white border border-[#E5E7EB]" data-testid={`about-fact-${f.label.slice(0, 10).toLowerCase().replace(/\s+/g, '-')}`}>
                  <f.icon className="w-5 h-5 text-[#06B6D4] shrink-0 mt-0.5" />
                  <span className="text-sm text-[#111827] font-medium">{f.label}</span>
                </div>
              ))}
            </div>

            {/* Quote */}
            <blockquote className="border-l-4 border-[#06B6D4] pl-5 py-3 mt-6" data-testid="about-quote">
              <p className="text-[#111827] font-medium italic text-lg font-['Outfit']">
                "Security isn't a product you buy. It's a practice you build."
              </p>
            </blockquote>

            <a
              href="https://linkedin.com/in/kumarpiyus"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-linkedin-btn"
              className="inline-flex items-center px-5 py-2.5 rounded-lg bg-white text-[#111827] border border-[#E5E7EB] font-medium text-sm transition-all hover:border-[#0F172A] hover:bg-[#F9FAFB]"
            >
              <Linkedin className="mr-2 w-4 h-4" /> Connect on LinkedIn
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
